import api from '../api'
import { axios as $http } from 'cm'
import { renderSearchList, renderSupportList } from '../render/searchList'
import { throttle } from '../../../../public-resource/libs/utils/index'

class HotSearchList {
  constructor() {
    this.loading = false
    this.tabIdx = 0
    this.page = [1, 1]
    this.hasMore = [true, true]

    this.getListData()
    this.bindEvent()
  }
  getListData() {
    if (this.loading || !this.hasMore[this.tabIdx]) return
    this.loading = true
    $('.loading-more').show()

    let params = {
      format: 'json',
      sshzv: 0,
      page: this.page[this.tabIdx],
      tag_name: this.tabIdx ? 'hot_answer' : 'hot_question'
    }

    $http
      .get(api.getQaData, {
        params
      })
      .then(res => {
        res = res.data
        this.loading = false
        $('.loading-more').hide()
        if (+res.code === 0) {
          this.page[this.tabIdx]++
          if (!res.data.length) {
            this.hasMore[this.tabIdx] = false
            return
          }
          if (this.tabIdx) {
            $('.hotsearch-support').append(renderSupportList(res.data))
          } else {
            $('.hotsearch-search').append(renderSearchList(res.data))
          }
        } else {
          window.toast(res.message)
        }
      })
      .catch(() => {
        this.loading = false
        $('.loading-more').hide()
      })
  }
  bindEvent() {
    let that = this
    $('.hotsWrap .child_tab button').click(function() {
      let $this = $(this)
      if ($this.hasClass('active')) return

      that.tabIdx = $this.index()

      $this
        .addClass('active')
        .siblings()
        .removeClass('active')

      let statName = '热搜'
      let statType = that.tabIdx ? '高赞问题' : '热搜问题'

      window.yxl.stat.send({
        name: statName,
        properties: {
          对象: statType,
          行为: '点击'
        }
      })

      $('.hotsearch_ul ul')
        .eq(that.tabIdx)
        .show()
        .siblings()
        .hide()

      if (that.page[that.tabIdx] === 1) {
        that.getListData()
      }
    })

    let scroll = throttle(function() {
      // console.log($(this).innerHeight(), $(this).scrollTop(), this.scrollHeight)
      let height = $(this).innerHeight()
      let scrollHeight = this.scrollHeight
      let scrollTop = $(this).scrollTop()

      if (scrollTop > 0 && height + scrollTop > scrollHeight - 20) {
        that.getListData()
      }
    }, 500)
    $('.hotsWrap').on('scroll', scroll)
  }
}

module.exports = HotSearchList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/modules/hotSearchList.js